export default __webpack_public_path__ + "static/media/paraKlein.774df0d9.jpg";